import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TermsOfUse } from 'src/app/models/terms-of-use.model';
import { TokenHelper } from 'src/app/services/helpers/token.helper';
import { LookupService } from 'src/app/services/lookup.service';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { ToastService } from 'src/app/services/ui/toast.service';
import { UserAuthService } from 'src/app/services/user-auth.service';
import { ToastType } from '../toast/models/toast-type.enum';
import { Toast } from '../toast/models/toast.model';

@Component({
	selector: 'terms-of-use',
	templateUrl: './terms-of-use.component.html',
	styleUrls: ['./terms-of-use.component.scss']
})
export class TermsOfUseComponent implements OnInit {

	public termsOfUse: TermsOfUse;
	public hasUserAcceptedTerms: boolean;
	public isEnabled = false;

	constructor(
		private userAuthService: UserAuthService,
		private activatedRoute: ActivatedRoute,
		private router: Router
	) {
		this.termsOfUse = this.activatedRoute.snapshot.data.termsOfUse;
	}

	@ViewChild('agreeButton') elementView: ElementRef;
	@ViewChild('termsContainer') elementTerms: ElementRef;
	ngOnInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;
	}

	@HostListener('window:scroll', ['$event']) // for window scroll events
	onScroll(event) {
		const epsilon = 1; // Acceptable fractional difference - allows for a small margin to account for sub-pixel differences.
		if (event.target.scrollTop >= event.target.scrollHeight - event.target.offsetHeight - epsilon) {
			this.isEnabled = true;
		}
	}

	public updateUserTermsAcceptance(): void {
		GlobalSettingsService.isSecondaryLoaderLoading = true;
		this.userAuthService.updateUserTermsAcceptance(TokenHelper.getToken(this.activatedRoute)).subscribe(() => {
			this.router.navigate(['../'], {relativeTo: this.activatedRoute});

			GlobalSettingsService.isSecondaryLoaderLoading = false;
		}, () => {
			GlobalSettingsService.isSecondaryLoaderLoading = false;

			ToastService.pushToast({
				icon: 'error',
				text: 'Accept could not be completed!',
				type: ToastType.Error
			} as Toast);

			this.router.navigate(['../'], {relativeTo: this.activatedRoute});
		});
	}
}

